import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthStore } from '../store/auth.store';
import { IncompleteProfileFundingDialogComponent } from '../components/incomplete-profile-funding-dialog/incomplete-profile-funding-dialog.component';
import { firstValueFrom } from 'rxjs';

/**
 * Guard que bloquea el acceso a poner fondos si el usuario no ha completado su perfil
 * y la configuración force_user_personal_info está activa.
 */
export const completeProfileGuard: CanActivateFn = async (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const dialog = inject(MatDialog);

  const config = authStore.appConfig() as any;
  const forceInfo = config?.force_user_personal_info === true || config?.force_user_personal_info === 'true';
  if (!forceInfo) return true;

  const metadata = (authStore.customer()?.metadata as any) || {};
  const hasMissing = !metadata.occupationId || !metadata.phone || !metadata.idCard || !metadata.address;

  if (!hasMissing) return true;

  const dialogRef = dialog.open(IncompleteProfileFundingDialogComponent, {
    width: '400px',
    maxWidth: '90vw',
    disableClose: true,
  });

  const action = await firstValueFrom(dialogRef.afterClosed());

  if (action === 'complete') {
    router.navigate(['/settings/profile']);
  } else {
    router.navigate(['/deposit']);
  }

  return false;
};
